/*
 * @Author: your name
 * @Date: 2021-04-29 09:17:01
 * @LastEditTime: 2021-05-12 11:29:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/rebates/api.js
 */
import request from '@/router/axios';

//全部合同附件列表
export function putInRecordRebateList(query) {
  return request({
    url: '/api/putInRecordRebate/page',
    method: 'get',
    params: query
  })
}
//查看返点详情  
export function putInRecordRebateDetail(query) {
    return request({
      url: '/api/putInRecordRebate/detail',
      method: 'get',
      params: query
    })
  }


// 确认返点
export function putInRecordRebateConfirm(obj) {
  return request({
    url: '/api/putInRecordRebate/confirm ' ,
    method: 'put',
    data: obj
  })
}